<template>
  <div style="display: flex; align-items: center;">
    <Pie
        ref="pieRef"
        :data="pieData"
        :options="pieOptions"
        :redraw="true"
        style="flex:1; max-height:30vh;"
    />
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import axios from '@/services/axios'
import { Pie } from 'vue-chartjs'
import {
  Chart,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js'

Chart.register(ArcElement, Tooltip, Legend)

const props = defineProps({
  endpoint: { type: String, default: '/dashboard/receitas-receber-mensal' },
  dataInicio: { type: String, required: true },
  dataFim:    { type: String, required: true }
})

const pieData = ref({
  labels: [],
  datasets: [{
    data: [],
    backgroundColor: [
      '#4A90E2', // Matrículas
      '#1ABC9C', // Mensalidades
      '#F5A623', // Aulas Avulsas
      '#E74C3C', // Aulas Experimentais
      '#9B59B6', // Vendas da Loja
      '#34495E'  // Receitas Gerais
    ]
  }]
})

const pieOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: true,
      text: 'Total a Receber por Tipo',
      align: 'start'
    },
    legend: {
      display: true,
      position: 'right',
      align: 'center'
    },
    tooltip: {
      callbacks: {
        // formata cada fatia normalmente
        label(ctx) {
          const val = ctx.parsed
          return `${ctx.label}: ${val.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2
          })}`
        },
        // footer exibirá o total de todas as fatias
        footer(ctxs) {
          // ctxs é array de items (aqui só 1, mas chamamos reduce pra garantir)
          const chart = ctxs[0].chart
          const total = chart.data.datasets[0].data
            .reduce((sum, v) => sum + v, 0)
          return `Total: ${total.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2
          })}`
        }
      },
      // mostra o footer
      footerFont: { weight: 'bold' }
    }
  }
}

const pieRef = ref(null)

async function fetchPie() {
  try {

    const { data } = await axios.get(
      props.endpoint,
      { params: { dataInicio: props.dataInicio, dataFim: props.dataFim } }
    )

    // soma cada série
    const totals = [
      data.series.matriculas.reduce((a,b)=>a+b,0),
      data.series.mensalidades.reduce((a,b)=>a+b,0),
      data.series.aulasAvulsas.reduce((a,b)=>a+b,0),
      data.series.aulasExperimentais.reduce((a,b)=>a+b,0),
      data.series.vendasLoja.reduce((a,b)=>a+b,0),
      data.series.receitasGerais.reduce((a,b)=>a+b,0)
    ]

   pieData.value = {
     labels: [
       'Matrículas',
       'Mensalidades',
       'Aulas Avulsas',
       'Aulas Experimentais',
       'Vendas da Loja',
       'Receitas Gerais'
     ],
     datasets: [{
       data: totals,
       backgroundColor: [
         '#4A90E2',
         '#1ABC9C',
         '#F5A623',
         '#E74C3C',
         '#9B59B6',
         '#34495E'
       ]
     }]
   }

  } catch (e) {
    console.error('Erro ao carregar pie:', e)
  }
}

onMounted(fetchPie)
watch(
  () => [props.dataInicio, props.dataFim],
  fetchPie
)
</script>

